import { v4 as uuid } from "uuid"

export const useUUID = (start: number, end: number) => {
    return uuid().substring(start, end)
}